import { ReactNode, useEffect } from 'react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { useOktaAuth } from '@okta/okta-react'
import { Outlet, Route } from 'react-router-dom'

const OKTA_ORIGINAL_URI_STORAGE_KEY = 'ssp.okta.originalUri'

const OktaAuthRequired = () => {
	const { oktaAuth, authState } = useOktaAuth()

	useEffect(() => {
		if (!authState) {
			return
		}

		if (!authState?.isAuthenticated) {
			const originalUri = toRelativeUrl(
				window.location.href,
				window.location.origin
			)
			window.sessionStorage.setItem(OKTA_ORIGINAL_URI_STORAGE_KEY, originalUri)
			oktaAuth.setOriginalUri(originalUri)
			oktaAuth.signInWithRedirect()
		}
	}, [oktaAuth, authState])

	if (!authState || !authState?.isAuthenticated) {
		return <h2>Loading...</h2>
	}

	return <Outlet />
}

const withOktaAuthRequired = (path: string, component: ReactNode) => {
	return (
		<Route path={path} element={<OktaAuthRequired />}>
			<Route path="" element={component} />
		</Route>
	)
}

export default withOktaAuthRequired
